import React from "react";
import { Link } from "react-router-dom";
import {
  Brain,
  HeartPulse,
  SmilePlus,
  Dna,
  Video,
  Globe,
  Biohazard,
  Radiation,
  Star,
  User,
  BookOpen,
  Stethoscope,
  PackageSearch,
} from "lucide-react";
import { banner_style } from "../Styles/styles";

const data = {
  event: {
    title: "About Us",
    date: "25th - 27th June 2025",
    organizer: "Helix Conferences",
    // Changed from strings with HTML to React nodes (JSX)
    description: [
      <>
        Our renowned{" "}
        <Link
          to="/public-health-conference-tracks/"
          target="blank"
          rel="noopener noreferrer"
          className="text-blue-600 font-bold"
        >
          Global Health Summits
        </Link>{" "}
        attract participants from across the World, creating a truly
        International dialogue around Health Equity, Disease Prevention, Health
        Systems Strengthening, and emerging Health Technologies. These Summits
        serve as a hub for sharing insights, forming partnerships, and driving
        change in the Global Health landscape.
      </>,
      <>
        Helix Conferences is committed to making a lasting impact through
        Education and Collaboration. We meticulously design our{" "}
        <Link
          to="https://helixconferences.com/blog.php"
          target="blank"
          className="text-blue-600 font-bold"
          title="Health Conferences Blog"
        >
          Health Conferences
        </Link>{" "}
        to address current Trends, Challenges, and Innovations in Public Health.
        From Non-Communicable Diseases to Mental Health, Climate Change, and
        Global Pandemics, our Events cover a broad range of critical topics.
      </>,
      <>
        Stay informed about upcoming top Public Health Events, register for our
        prestigious Global Health Summits, and connect with a Global Network of
        Professionals dedicated to improving Health outcomes Worldwide.
      </>,
    ],
  },
  whyAttend: [
    "Attending the Global Oral Medicine Conclave offers unparalleled opportunities for professional growth. Participants will have access to:",
    "Expert-led sessions and workshops: Gain insights from world-renowned speakers who are pioneers in oral medicine and dental research.",
    "Networking opportunities: Connect with global leaders, researchers, and peers to build partnerships and foster collaborations.",
    "Innovative technology showcases: Explore the latest tools, products, and technologies revolutionizing oral healthcare.",
    "Research presentations: Discover new scientific findings and clinical studies that impact the diagnosis and treatment of oral diseases.",
    "Helix Conferences is committed to delivering an experience that combines scientific excellence with practical applications, ensuring attendees leave with actionable knowledge to advance practices.",
  ],
  aboutHelix: [
    "Helix Conferences has a longstanding reputation as a premier global conference organizer specializing in healthcare and scientific events. With years of expertise in curating impactful conferences, Helix ensures that every detail of the 2025 Oral Medicine Conference is crafted to deliver maximum value to attendees.",
  ],
  whoShouldAttend: [
    "Oral medicine specialists and dentists",
    "Researchers and academicians in dental sciences",
    "Healthcare providers involved in oral health",
    "Pharmaceutical and medical device professionals",
    "Students and trainees in dentistry and related fields",
  ],
  join: [
    "The 2025 Public Health Conference by Helix Conferences is more than just an event, it's a global movement toward better public health through science, technology, and collaboration. Join thousands of professionals from around the world as they share knowledge, advance research, and inspire innovation in public health.",
  ],
  themes: [
    {
      icon: Brain,
      title: "AI in Healthcare",
      description: "Researchers & Academicians",
    },
    {
      icon: HeartPulse,
      title: "Cardiovascular Diseases",
      description: "Healthcare Providers & Clinicians",
    },
    {
      icon: SmilePlus,
      title: "Mental Health Innovations",
      description: "Medical Device Innovators",
    },
    {
      icon: Dna,
      title: "Genetics & Personalized Medicine",
      description: "Government Officials & Policymakers",
    },
    {
      icon: Video,
      title: "Telemedicine & Digital Health",
      description: "Pharmaceutical & Biotech Professionals",
    },
    {
      icon: Globe,
      title: "Public Health & Global Systems",
      description: "Students & Early-Career Professionals",
    },
    {
      icon: Biohazard,
      title: "Infectious Diseases & Security",
      description: "NGOs & Public Health Organizations",
    },
    {
      icon: Radiation,
      title: "Cancer Research & Treatment",
      description: "Investors & Healthcare Entrepreneurs",
    },
  ],

  highlights: [
    {
      title: "Keynote Speakers",
      description: "Leading experts in Medicine, Policy, and Tech.",
    },

    {
      title: "Workshops & Seminars",
      description: "Interactive sessions on current topics.",
    },

    {
      title: "Exhibition",
      description: "Showcase of cutting-edge Healthcare Tech.",
    },

    {
      title: "Networking Opportunities",
      description: "Connect with Global Leaders.",
    },

    {
      title: "Accredited Learning",
      description: "Earn CME credits by attending the conference.",
    },

    {
      title: "Collaboration Building",
      description: "Initiate joint research projects or institutional studies.",
    },

    {
      title: "Publication Opportunities",
      description: "Proceedings partnerships for presented work.",
    },

    {
      title: "Awards & Recognition",
      description: "Compete for best paper prizes and other accolades.",
    },
  ],
  dates: {
    eventDate: "25th - 27th June 2025",
    venue: "Novotel Valencia, Spain",
    registrationDeadline: "10th June 2025",
  },
};

const AboutPublicHealth = () => {
  return (
    <div className="w-full 2xl:max-w-[1280px] mx-auto justify-center items-center text-center">
      <div className={`${banner_style} w-full mx-auto about-banner`}>
        <h1 className="text-slate-100 text-3xl sm:text-5xl md:text-6xl font-bold px-4 z-10">
          {data.event.title}
        </h1>
      </div>

      <h1 className="text-4xl mt-2 font-bold text-one">
        A Conference ON PUBLIC HEALTH-2025
      </h1>
      <p className="text-center text-gray-600 text-3xl mb-6">
        <strong>
          25<sup>th</sup> - 27<sup>th</sup> June 2025
        </strong>
      </p>

      {data.event.description.map((desc, idx) => (
        <p
          key={idx}
          className="mb-6 text-lg leading-relaxed text-center w-full min-w-5xl px:2 md:px-12 lg:px-24"
        >
          {desc}
        </p>
      ))}

      {/* Why Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Why Attend the 2025 Oral Medicine Conference?</h2>
        {data.whyAttend.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* About Helix Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Helix Conferences: Leading the Way in Event Organization</h2>
        {data.aboutHelix.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* Who Should Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Who Can Attend?</h2>
        <ul className="list-disc list-inside text-base text-gray-700 text-center w-full">
          {data.whoShouldAttend.map((item, idx) => (
            <li key={idx} className="mb-2">{item}</li>
          ))}
        </ul>
      </section> */}

      {/* Join Section */}
      <section className="mb-10 text-center w-full min-w-4xl px-2 md:px-12 lg:px-24">
        <h2 className="text-3xl font-bold text-one mb-4 w-full">
          Join the Global Community at Public Health Conference 2025
        </h2>
        {data.join.map((para, idx) => (
          <p
            key={idx}
            className="mb-6 text-lg leading-relaxed text-center w-full min-w-5xl px:2 md:px-12 lg:px-24"
          >
            {para}
          </p>
        ))}
      </section>

      {/* Themes Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl my-8 font-bold text-one">Who Can Attend...</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <User className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Public Health Professionals
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <BookOpen className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Academics & Researchers
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <Stethoscope className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Healthcare Administrators
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <PackageSearch className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Healthcare product and Service providers
            </h3>
          </div>
          {/* <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <GraduationCap className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">Students and trainees in dentistry and related fields</h3>
          </div> */}
        </div>
      </section>

      {/* Highlights Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl font-bold text-one mb-8">Event Highlights</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full items-start">
          {data.highlights.map((highlight, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-4 text-md text-gray-800 text-left flex items-start shadow-sm "
            >
              <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 mr-3 mt-1" />
              <div className="flex flex-wrap items-start">
                <h3 className="font-semibold whitespace-nowrap mr-1">
                  {highlight.title} –
                </h3>
                <p className="text-md text-gray-600 flex-1">
                  {highlight.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Dates Section */}
      {/* <section className="mb-16 text-center w-full md:px-12 px-4">
        <h2 className="text-4xl font-bold text-one mb-8">
          Important Dates
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full text-sm">
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Calendar className="w-6 h-6 text-one mb-2" />
            <strong>Event Date</strong>
            <p>{data.dates.eventDate}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Globe className="w-6 h-6 text-one mb-2" />
            <strong>Proposed Venue</strong>
            <p>{data.dates.venue}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <BadgeCheck className="w-6 h-6 text-one mb-2" />
            <strong>Registration Deadline</strong>
            <p>{data.dates.registrationDeadline}</p>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPublicHealth;

